@if (visible) {
    <div class="impersonation-banner">
        <mat-icon>support_agent</mat-icon>
        <span class="impersonation-banner__text">
            Modo soporte activo — Tenant <strong>{{ tenantId }}</strong>
        </span>
        <span class="impersonation-banner__timer"
            [class.impersonation-banner__timer--warning]="countdown <= 120"
            [class.impersonation-banner__timer--danger]="countdown <= 60">
            <mat-icon>schedule</mat-icon>{{ tiempoTranscurrido }}
        </span>
        <button mat-stroked-button class="impersonation-banner__manage"
                (click)="irAPanel()">
            <mat-icon>open_in_new</mat-icon>Gestionar
        </button>
        <button mat-icon-button class="impersonation-banner__exit"
                (click)="salir()" title="Finalizar sesión de soporte">
            <mat-icon>logout</mat-icon>
        </button>
    </div>
}
